var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6738 9.82617L32.4852 45.9784L18.1524 50L3.85904 45.9841L0.673828 9.82617H35.6738Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7555 43.6765L32.4803 12.7827H18.1738V46.9262L29.7555 43.6765Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97461 26.1931L8.36732 30.6277H18.1726V26.1931H7.97461Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1726 17.2173H18.1575H7.18555L7.58385 21.652H18.1726V17.2173Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1739 42.3241V37.7102L18.1547 37.7154L13.2749 36.3818L12.9629 32.845H10.5917H8.56445L9.17832 39.808L18.1538 42.3297L18.1739 42.3241Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91211 0H14.219V2.24609H11.1314V4.49219H14.219V6.73828H8.91211V0Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2793 0H20.5862V1.95312H17.4986V2.34375H20.5862V6.83594H15.2793V4.78516H18.367V4.39453H15.2793V0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6465 0H26.9534V1.95312H23.8657V2.34375H26.9534V6.83594H21.6465V4.78516H24.7341V4.39453H21.6465V0Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5537 30.6276L23.0451 36.379L18.1582 37.714V42.3276L27.1408 39.808L27.2067 39.0588L28.2363 27.3839L28.3432 26.1931L29.1343 17.2173H18.1582V21.652H24.3324L23.9337 26.1931H18.1582V30.6276H23.5537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.19659d4550bfac7e7db57dac34064fce.svg";
export { ForwardRef as ReactComponent };